import { Card, Error, Field, Icon, Spinner } from '@/components/generic';
import { copyToClipboard } from '@/utils/string';
import { useGetAccountInfo } from '@package/smart-wallet/hooks';
import { useTranslation } from 'react-i18next';

const ProfileInformation = () => {
  const { t } = useTranslation();
  const { isLoading, userEmail, smartAccountAddress } = useGetAccountInfo();

  return (
    <>
      <Card title={t('profile.information.title')}>
        <div className='flex flex-col gap-8 p-5 pt-0 max-lg:px-3'>
          {isLoading ? (
            <Spinner />
          ) : (
            <Field
              label={t('profile.information.email.label')}
              placeholder={t('profile.information.email.placeholder')}
              type='email'
              value={userEmail ?? ''}
              readOnly
              validated
            />
          )}
          {isLoading ? (
            <Spinner />
          ) : (
            <Field
              label={t('profile.information.wallet_address.label')}
              placeholder={t('profile.information.wallet_address.placeholder')}
              value={smartAccountAddress ?? ''}
              readOnly
              icon={
                <button
                  type='button'
                  onClick={() => copyToClipboard(smartAccountAddress)}
                  className={`absolute top-1/2 -translate-y-1/2 transition-all hover:fill-t-primary right-5  hover:scale-120`}
                >
                  <Icon className={`w-4 h-4 fill-t-secondary`} name={'copy'} />
                </button>
              }
            />
          )}
          <Error error message={t('profile.information.kyc_status_pending')} />
        </div>
      </Card>
    </>
  );
};

export default ProfileInformation;
